import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ab974c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buton" }, "?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XyzTransition = _resolveComponent("XyzTransition")!

  return (_openBlock(), _createElementBlock("div", {
    class: "wrapper",
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showPopHover = !$setup.showPopHover)),
    ref: "popWrapper"
  }, [
    _hoisted_1,
    _createVNode(_component_XyzTransition, { xyz: "fade down-1" }, {
      default: _withCtx(() => [
        ($setup.showPopHover)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["content", [$setup.position, $setup.positionX]]),
              ref: "popHover"
            }, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512))
}